/* Luggage Depot theme scripts */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var n = Number(cents) / 100;
    function fix(dec, thou, decSep) {
      var parts = n.toFixed(dec).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (parts[1] ? decSep + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fix(0, ',', '.');
        case 'amount_with_comma_separator': return fix(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fix(0, '.', ',');
        default: return fix(2, ',', '.');
      }
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(html, isError) {
    var el = $('[data-toast]');
    if (!el) return;
    el.innerHTML = html;
    el.classList.toggle('toast--error', !!isError);
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4000);
  }

  /* ---------- Header: mobile menu + search ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-menu-open]');
    var nav = $('[data-mobile-nav]');
    if (open && nav) {
      nav.hidden = false;
      open.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = $('a, button', nav); if (first) first.focus();
      return;
    }
    if (nav && !nav.hidden && (e.target.closest('[data-menu-close]') || e.target === nav)) {
      closeMenu();
      return;
    }
    var st = e.target.closest('[data-search-toggle]');
    if (st) {
      var bar = $('[data-search]');
      bar.hidden = !bar.hidden;
      st.setAttribute('aria-expanded', String(!bar.hidden));
      if (!bar.hidden) $('input[type=search]', bar).focus();
    }
  });
  function closeMenu() {
    var nav = $('[data-mobile-nav]');
    if (!nav) return;
    nav.hidden = true;
    document.body.style.overflow = '';
    var btn = $('[data-menu-open]');
    if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var nav = $('[data-mobile-nav]');
      if (nav && !nav.hidden) closeMenu();
      var bar = $('[data-search]');
      if (bar && !bar.hidden) { bar.hidden = true; }
    }
  });

  /* ---------- Hero slider ---------- */
  function initSlider(root) {
    var slides = $$('[data-slide]', root);
    var dots = $$('[data-dot]', root);
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('a, button', s).forEach(function (el) { el.tabIndex = on ? 0 : -1; });
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function stop() { clearInterval(timer); }
    function start() {
      stop();
      if (root.dataset.autoplay === 'true' && !reduce && !window.Shopify?.designMode) {
        timer = setInterval(function () { go(i + 1); }, (Number(root.dataset.speed) || 5) * 1000);
      }
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(Number(d.dataset.dot)); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); start(); }
      x0 = null;
    });
    root._go = go;
    go(0);
    start();
  }
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-slide]');
    if (!slide) return;
    var root = slide.closest('[data-slider]');
    if (root && root._go) root._go($$('[data-slide]', root).indexOf(slide));
  });

  /* ---------- Card swatches ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-swatch]');
    if (!sw) return;
    var card = sw.closest('[data-card]');
    $$('[data-swatch]', card).forEach(function (s) { s.classList.toggle('is-active', s === sw); });
    var input = $('[data-card-variant]', card);
    if (input) input.value = sw.dataset.variant;
    var img = $('.card__img', card);
    if (img && sw.dataset.image) { img.removeAttribute('srcset'); img.src = sw.dataset.image; }
    var price = $('[data-price]', card);
    if (price && sw.dataset.price) {
      price.classList.toggle('price--sale', !!sw.dataset.compare);
      price.innerHTML = '<span class="price__current">' + sw.dataset.price + '</span>' +
        (sw.dataset.compare ? '<s class="price__compare">' + sw.dataset.compare + '</s>' : '');
    }
    var btn = $('.card__atc', card);
    var available = sw.dataset.available === 'true';
    if (btn) {
      btn.disabled = !available;
      var label = $('[data-atc-label]', btn);
      if (label) label.textContent = available ? 'Add to Cart' : 'Sold Out';
    }
  });

  /* ---------- Wishlist hearts (saved in this browser) ---------- */
  var WKEY = 'ld-wishlist';
  function getWish() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (err) { return []; } }
  function setWish(list) { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (err) {} }
  function paintWish(scope) {
    var list = getWish();
    $$('[data-wish]', scope).forEach(function (b) { b.setAttribute('aria-pressed', String(list.indexOf(b.dataset.wish) > -1)); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    var list = getWish(), id = b.dataset.wish, at = list.indexOf(id);
    if (at > -1) list.splice(at, 1); else list.push(id);
    setWish(list);
    b.setAttribute('aria-pressed', String(at === -1));
  });

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = $('button[type=submit]', form);
    var label = btn ? $('[data-atc-label]', btn) : null;
    var original = label ? label.textContent : '';
    if (btn) btn.disabled = true;
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (res) { return res.json().then(function (data) { if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart'); return data; }); })
      .then(function () { return fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; });
        if (label) label.textContent = 'Added';
        toast('Added to your cart <a href="' + window.routes.cart_url + '">View cart</a>');
        setTimeout(function () { if (label) label.textContent = original; if (btn) btn.disabled = false; }, 1600);
      })
      .catch(function (err) {
        if (label) label.textContent = original;
        if (btn) btn.disabled = false;
        toast(err.message, true);
      });
  });

  /* ---------- Product page ---------- */
  function showMedia(root, thumb) {
    var main = $('.product__main-img', root);
    if (main && thumb.dataset.src) { main.removeAttribute('srcset'); main.src = thumb.dataset.src; }
    $$('[data-thumb]', root).forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (t) showMedia(t.closest('[data-product]'), t);
    var q = e.target.closest('[data-qty]');
    if (q) {
      var input = $('input', q.parentNode);
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(q.dataset.qty));
    }
  });
  function initProduct(root) {
    var dataEl = $('[data-variants]', root);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-input]')) return;
      var sets = $$('fieldset[data-option-index]', root);
      var selected = sets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
      sets.forEach(function (fs, k) { var out = $('[data-option-value]', fs); if (out) out.textContent = selected[k]; });
      var v = variants.find(function (x) { return x.options.every(function (o, k) { return o === selected[k]; }); });
      var btn = $('[data-atc]', root);
      var label = $('[data-atc-label]', btn);
      var stock = $('[data-stock]', root);
      function setStock(ok, txt) {
        if (!stock) return;
        stock.classList.toggle('stock--out', !ok);
        $('[data-stock-label]', stock).textContent = txt;
        $('[data-stock-sub]', stock).textContent = ok ? '· Ready to ship in 1–2 business days' : '';
      }
      if (!v) { btn.disabled = true; label.textContent = 'Unavailable'; setStock(false, 'Unavailable'); return; }
      setStock(v.available, v.available ? 'In stock' : 'Out of stock');
      $('[data-variant-id]', root).value = v.id;
      btn.disabled = !v.available;
      label.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      var price = $('[data-price]', root);
      if (price) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        price.classList.toggle('price--sale', !!sale);
        price.innerHTML = '<span class="price__current">' + formatMoney(v.price) + '</span>' +
          (sale ? '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>' : '');
      }
      if (v.featured_media) {
        var thumb = $('[data-media-id="' + v.featured_media.id + '"]', root);
        if (thumb) showMedia(root, thumb);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  }

  /* ---------- Video modal ---------- */
  document.addEventListener('click', function (e) {
    var tile = e.target.closest('[data-video-id]');
    if (tile) {
      var dialog = $('[data-video-modal]', tile.closest('[data-video-section]'));
      var frame = $('[data-video-frame]', dialog);
      var id = encodeURIComponent(tile.dataset.videoId);
      var src = tile.dataset.videoType === 'vimeo'
        ? 'https://player.vimeo.com/video/' + id + '?autoplay=1'
        : 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
      frame.innerHTML = '<iframe src="' + src + '" title="Video" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
      if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
      return;
    }
    var close = e.target.closest('[data-video-close]');
    var dlg = close ? close.closest('dialog') : (e.target.matches && e.target.matches('[data-video-modal]') ? e.target : null);
    if (dlg) dlg.close();
  });
  document.addEventListener('close', function (e) {
    if (e.target.matches && e.target.matches('[data-video-modal]')) $('[data-video-frame]', e.target).innerHTML = '';
  }, true);

  /* ---------- Tracking form: strip spaces ---------- */
  document.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-track-form]')) return;
    var i = e.target.querySelector('input[name="trknbr"]');
    if (i) i.value = i.value.replace(/\s+/g, '');
  }, true);

  /* ---------- Sort select ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });

  /* ---------- Scroll reveal ---------- */
  function initReveal(scope) {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('js-reveal');
    var groups = ['.img-grid', '.grid--products', '.video-grid', '.trust__grid'];
    var targets = [];
    $$('main .section-head, main .promo, main .hero', scope).forEach(function (el) { targets.push(el); });
    groups.forEach(function (g) {
      $$(g, scope).forEach(function (grid) {
        Array.prototype.forEach.call(grid.children, function (child, i) { child.style.setProperty('--rd', (i % 4) * 0.12 + 's'); targets.push(child); });
      });
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (t) { if (!t.hasAttribute('data-reveal')) { t.setAttribute('data-reveal', ''); io.observe(t); } });
  }

  /* ---------- Content cleanup (policies & pages) ---------- */
  function cleanContent() {
    var scope = document.getElementById('MainContent');
    if (!scope) return;
    $$('a[href*="utm_source=chatgpt.com"]', scope).forEach(function (a) {
      a.setAttribute('href', a.getAttribute('href').replace(/([?&])utm_source=chatgpt\.com&?/, '$1').replace(/[?&]$/, ''));
    });
    var fixes = [[/support@luggagedepot\.com/g, 'support@luggagedepot.shop'], [/5:00 PM \(PT\)/g, '5:00 PM (CST)']];
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var t = node.nodeValue, n = t;
      fixes.forEach(function (f) { n = n.replace(f[0], f[1]); });
      if (n !== t) node.nodeValue = n;
    }
    $$('a[href^="mailto:support@luggagedepot.com"]', scope).forEach(function (a) { a.setAttribute('href', 'mailto:support@luggagedepot.shop'); });
  }

  /* ---------- Init ---------- */
  function init(scope) {
    $$('[data-slider]', scope).forEach(initSlider);
    $$('[data-product]', scope).forEach(initProduct);
    paintWish(scope);
    cleanContent();
    if (!window.Shopify || !window.Shopify.designMode) initReveal(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
